
import React, { useState } from "react";
import './css/faq.css'; 
import { NavLink } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
const Faq = () => {
  const { t } = useTranslation();
  const [language, setLanguage] = useState(localStorage.getItem('selectedLanguage'));
  return ( 
    <div className='home'> 
      <div className="maine-div">
          <div className="container-fluid box-wrapper difficult">  
          <div class="page-header pb-5">
                <div class="box-wrapper mx-auto text-center position-relative">
                    <NavLink to="/profile" className="page-header-back"><img src="/image/back.png" className='arrow' alt="Avatar" /></NavLink>
                    <span class="modal-level-title levels-title">{t('91')}</span>
                </div>
            </div> 
             <div class="home-profile">
              {language==3?(<>
                <ol>
                  <li><strong> O que &eacute; o servi&ccedil;o QUIZ MASTER?</strong></li>
                  <p>O QUIZ MASTER &eacute; um servi&ccedil;o digital que permite aos clientes da Vodacom ganhar v&aacute;rios pr&eacute;mios instant&acirc;neos ao acumular estrelas de vit&oacute;ria, respondendo corretamente &agrave;s perguntas apresentadas.</p>

                  </ol>
                  <ol start="2">
                  <li><strong> Quem pode utilizar o servi&ccedil;o QUIZ MASTER?</strong></li>
                  <p>Todos os clientes da Vodacom s&atilde;o eleg&iacute;veis para utilizar o servi&ccedil;o QUIZ MASTER.</p>

                  </ol>
                  <ol start="3">
                  <li><strong> Quais s&atilde;o os benef&iacute;cios que os clientes podem encontrar no servi&ccedil;o QUIZ MASTER?</strong></li>
                  <p>Os clientes ter&atilde;o a oportunidade de ganhar diversos pr&eacute;mios. A distribui&ccedil;&atilde;o dos pr&eacute;mios &eacute; feita da seguinte forma:</p>

                  </ol>
                  <table >
                  <tbody>
                  <tr className="tableHeader">
                  <td>
                  <p><strong>N&uacute;mero de Perguntas Respondidas Corretamente</strong></p>
                  </td>
                  <td>
                  <p><strong>Estrelas</strong></p>
                  </td>
                  <td>
                  <p><strong>Pr&eacute;mios</strong></p>
                  </td>
                  <td>
                  <p><strong>Validade dos Pr&eacute;mios</strong></p>
                  </td>
                  <td>
                  <p><strong>Valor dos Pr&eacute;mios</strong></p>
                  </td>
                  </tr>
                  <tr>
                  <td>
                  <p>100</p>
                  </td>
                  <td>
                  <p>1000</p>
                  </td>
                  <td>
                  <p>22Min (OnNet)</p>
                  </td>
                  <td>
                  <p>1 Dia</p>
                  </td>
                  <td>
                  <p>10MT</p>
                  </td>
                  </tr>
                  <tr>
                  <td>
                  <p>80</p>
                  </td>
                  <td>
                  <p>800</p>
                  </td>
                  <td>
                  <p>206MB- 1 dia</p>
                  </td>
                  <td>
                  <p>1 Dia</p>
                  </td>
                  <td>
                  <p>7MT</p>
                  </td>
                  </tr>
                  <tr>
                  <td>
                  <p>500</p>
                  </td>
                  <td>
                  <p>5000</p>
                  </td>
                  <td>
                  <p>25Min (Bonnet)+1.3GB+500 SMS</p>
                  </td>
                  <td>
                  <p>7 Dias</p>
                  </td>
                  <td>
                  <p>100MT</p>
                  </td>
                  </tr>
                  </tbody>
                  </table>
                  <br/>


                  <table>
                  <tbody>
                  <tr className="tableHeader">
                  <td>
                  <p><strong>Pacote</strong></p>
                  </td>
                  <td>
                  <p><strong>Pre&ccedil;o</strong></p>
                  </td>
                  <td>
                  <p><strong>N&uacute;mero de Perguntas por Dia</strong></p>
                  </td>
                  </tr>
                  <tr>
                  <td>
                  <p>Di&aacute;rio</p>
                  </td>
                  <td>
                  <p>3MT</p>
                  </td>
                  <td>
                  <p>10 perguntas</p>
                  </td>
                  </tr>
                  <tr>
                  <td>
                  <p>Semanal</p>
                  </td>
                  <td>
                  <p>20MT</p>
                  </td>
                  <td>
                  <p>10 perguntas gr&aacute;tis a cada 7 dias</p>
                  </td>
                  </tr>
                  <tr>
                  <td>
                  <p>Mensal</p>
                  </td>
                  <td>
                  <p>50MT</p>
                  </td>
                  <td>
                  <p>10 perguntas gr&aacute;tis a cada 30 dias</p>
                  </td>
                  </tr>
                  <tr>
                  <td>
                  <p>Pacote adicional de perguntas (por dia)</p>
                  </td>
                  <td>
                  <p>3MT</p>
                  </td>
                  <td>
                  <p>10 perguntas apenas</p>
                  </td>
                  </tr>
                  </tbody>
                  </table>
                  <br/>

                  <ol>
                  <li><strong>Como os clientes podem subscrever ao servi&ccedil;o QUIZ MASTER?</strong></li>
                  <p>Os clientes podem subscrever atrav&eacute;s dos seguintes canais:</p>
                  </ol>
                  <ul>
                  <li><strong><u>USSD</u></strong><u>: </u>Marcando *844# e escolhendo a op&ccedil;&atilde;o&nbsp;<strong>6 - Jogos</strong></li>
                  <li><strong><u>SMS: </u></strong><u>Para se subscrever envie</u><strong><u> OK </u></strong><u>para</u><strong><u> 84636 </u></strong></li>
                  <li><strong><u>PORTAL:</u></strong> Os clientes podem subscrever clicando no link do servi&ccedil;o <a href="https://vmz.quizzzmaster.com/">https://vmz.quizzzmaster.com/</a></li>
                  </ul>
                  <ol start="2">
                  <li><strong>Quanto custa o servi&ccedil;o QUIZ MASTER?</strong></li>
                  </ol>

                  <table>
                  <tbody>
                  <tr className="tableHeader">
                  <td>
                  <p><strong>Plano de Subscri&ccedil;&atilde;o</strong></p>
                  </td>
                  <td>
                  <p><strong>Pre&ccedil;o MT</strong></p>
                  </td>
                  <td>
                  <p><strong>Validade</strong></p>
                  </td>
                  </tr>
                  <tr>
                  <td>
                  <p>Di&aacute;rio</p>
                  </td>
                  <td>
                  <p>3</p>
                  </td>
                  <td>
                  <p>1 dia</p>
                  </td>
                  </tr>
                  <tr>
                  <td>
                  <p>Semanal</p>
                  </td>
                  <td>
                  <p>20</p>
                  </td>
                  <td>
                  <p>7 dias</p>
                  </td>
                  </tr>
                  <tr>
                  <td>
                  <p>Mensal</p>
                  </td>
                  <td>
                  <p>50</p>
                  </td>
                  <td>
                  <p>30 dias</p>
                  </td>
                  </tr>
                  </tbody>
                  </table>
                  <br/>

                  <ol start="3">
                  <li><strong>Como o cliente pode cancelar a subscri&ccedil;&atilde;o do servi&ccedil;o QUIZ MASTER?</strong></li>
                  <p>Os clientes podem cancelar a subscri&ccedil;&atilde;o de duas formas:</p>
                  </ol>

                  <ul>
                  <li>Enviando STOP para 84636.</li>
                  <li>Clicando no bot&atilde;o <strong>CANCELAR</strong> dentro do portal</li>
                  </ul>
              </>):(<>
                    <ol>
                    <li><strong>What is QUIZ MASTER Service?</strong></li>
                    <p>This is a digital service that allows Vodacom customers to win various instant prizes by accumulating winning stars from answering questions accurately and accordingly.</p>
                    </ol>
                    
                    <ol start="2">
                    <li><strong>Who is eligible to QUIZ MASTER Service?</strong></li>
                     <p>All Vodacom customers are eligible to use QUIZ MASTER service.</p>
                    </ol>
                   
                    <ol start="3">
                    <li><strong>What benefits can customers find on the QUIZ MASTER Service?</strong></li>
                     <p>Customers will have the opportunity to win various prizes. Prize distribution is as follows.</p>
                    </ol>
                   
                    <table>
                    <tbody>
                    <tr className="tableHeader">
                    <td>
                    <p><strong>Number of Questions answered correctly</strong></p>
                    </td>
                    <td>
                    <p><strong>Stars</strong></p>
                    </td>
                    <td>
                    <p><strong>Prizes</strong></p>
                    </td>
                    <td>
                    <p><strong>Validity of prizes</strong></p>
                    </td>
                    <td>
                    <p><strong>Prize of Prizes</strong></p>
                    </td>
                    </tr>
                    <tr>
                    <td>
                    <p>100</p>
                    </td>
                    <td>
                    <p>1000</p>
                    </td>
                    <td>
                    <p>22Min (OnNet)</p>
                    </td>
                    <td>
                    <p>1 Day</p>
                    </td>
                    <td>
                    <p>10MT</p>
                    </td>
                    </tr>
                    <tr>
                    <td>
                    <p>80</p>
                    </td>
                    <td>
                    <p>800</p>
                    </td>
                    <td>
                    <p>206MB- 1 day</p>
                    </td>
                    <td>
                    <p>1 Day</p>
                    </td>
                    <td>
                    <p>7MT</p>
                    </td>
                    </tr>
                    <tr>
                    <td>
                    <p>500</p>
                    </td>
                    <td>
                    <p>5000</p>
                    </td>
                    <td>
                    <p>25Min (Bonnet)+1.3GB+500 SMS</p>
                    </td>
                    <td>
                    <p>7 Days</p>
                    </td>
                    <td>
                    <p>100MT</p>
                    </td>
                    </tr>
                    </tbody>
                    </table>
                    <br/>


                    <table>
                    <tbody>
                    <tr className="tableHeader">
                    <td>
                    <p><strong>Pack </strong></p>
                    </td>
                    <td>
                    <p><strong>Price</strong></p>
                    </td>
                    <td>
                    <p><strong>Number of Questions per day</strong></p>
                    </td>
                    </tr>
                    <tr>
                    <td>
                    <p>Daily</p>
                    </td>
                    <td>
                    <p>3MT</p>
                    </td>
                    <td>
                    <p>10 questions</p>
                    </td>
                    </tr>
                    <tr>
                    <td>
                    <p>Weekly</p>
                    </td>
                    <td>
                    <p>20MT</p>
                    </td>
                    <td>
                    <p>10 questions free for each 7 days</p>
                    </td>
                    </tr>
                    <tr>
                    <td>
                    <p>Monthly</p>
                    </td>
                    <td>
                    <p>50MT</p>
                    </td>
                    <td>
                    <p>10 questions free for each 30 days</p>
                    </td>
                    </tr>
                    <tr>
                    <td>
                    <p>Additional question pack (per day)</p>
                    </td>
                    <td>
                    <p>3MT</p>
                    </td>
                    <td>
                    <p>10 questions only</p>
                    </td>
                    </tr>
                    </tbody>
                    </table>
                    <br/>


                    <ol start="4">
                    <li><strong>How can the customers subscribe to QUIZ MASTER Service?</strong></li>                    
                    <p>Customers can subscribe via the following channels.</p>
                    </ol>
                    <ul>
                    <li><strong><u>USSD</u></strong><u>: </u>Dialing *844# and choosing option 6 - Games</li>
                    <li><strong><u>SMS: </u></strong>To subscribe send OK to 84636</li>
                    <li><strong><u>PORTAL:</u></strong>Customers can subscribe by clicking on the service link</li>
                    </ul>
                    <p><a href="https://vmz.quizzzmaster.com/">https://vmz.quizzzmaster.com/</a></p>
                    <ol start="5">
                    <li><strong>How much does QUIZ MASTER Service charge?</strong></li>
                    </ol>
                    <table>
                    <tbody>
                    <tr className="tableHeader">
                    <td>
                    <p><strong>Subscription Plan</strong></p>
                    </td>
                    <td>
                    <p><strong>Price MT</strong></p>
                    </td>
                    <td>
                    <p><strong>Validity</strong></p>
                    </td>
                    </tr>
                    <tr>
                    <td>
                    <p>Daily</p>
                    </td>
                    <td>
                    <p>3</p>
                    </td>
                    <td>
                    <p>1 day</p>
                    </td>
                    </tr>
                    <tr>
                    <td>
                    <p>Weekly</p>
                    </td>
                    <td>
                    <p>20</p>
                    </td>
                    <td>
                    <p>7 days</p>
                    </td>
                    </tr>
                    <tr>
                    <td>
                    <p>Monthly</p>
                    </td>
                    <td>
                    <p>50</p>
                    </td>
                    <td>
                    <p>30 days</p>
                    </td>
                    </tr>
                    </tbody>
                    </table>
                    <br/>
                    <ol start="6">
                    <li><strong>How can customer opt-out of QUIZ MASTER Service?</strong></li>                    
                    <p>Customers can cancel their subscription in two ways:</p>
                    </ol>
                    <ul>
                    <li>By texting STOP to 84636.</li>
                    <li>Clicking the CANCEL button within the portal</li>
                    </ul>
              </>)}  
            </div> 
          </div>
      </div> 
    </div> 
  )
}

export default Faq